import { TypedConfiguredCarCatalogImages } from '~/graphql/__generated__/graphql';

export default function GetUrlFromImageSet(
	imageSets: TypedConfiguredCarCatalogImages[] | undefined | null,
	type: string,
) {
	if (!imageSets || imageSets.length < 1) return;
	return imageSets?.find((a) => a.type === type)?.images[0]?.url;
}

export function GetUrlArrayFromImageSet(imageSets: TypedConfiguredCarCatalogImages[] | undefined | null, type: string) {
	if (!imageSets || imageSets.length < 1) return;
	return imageSets?.find((a) => a.type === type)?.images?.map((b) => b?.url);
}

export function GetMediaFromImageSet(imageSets: TypedConfiguredCarCatalogImages[] | undefined | null, type: string) {
	if (!imageSets || imageSets.length < 1) return;
	return imageSets?.find((a) => a.type === type)?.images[0];
}

export function GetMediaArrayFromImageSet(
	imageSets: TypedConfiguredCarCatalogImages[] | undefined | null,
	type: string,
) {
	if (!imageSets || imageSets.length < 1) return;
	return imageSets?.find((a) => a.type === type)?.images?.map((b) => b);
}
